import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function FeeDashboard() {
  const navigate = useNavigate();
  const department = localStorage.getItem('department');
  const showObjectColumn = !!department;
  const classDivRaw = localStorage.getItem('classDiv') || '-';
  const udiseNumber = localStorage.getItem('udiseNumber');

  const [feeData, setFeeData] = useState([]);
  const [academicYear, setAcademicYear] = useState('');
  const [studentFeeData, setStudentFeeData] = useState({});
  const [studentData, setStudentData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState(null);
  const [expandedClasses, setExpandedClasses] = useState({});
const [classFeeTypeDiscounts, setClassFeeTypeDiscounts] = useState({});
const [classFeeTypeReceived, setClassFeeTypeReceived] = useState({});
const [hostelStudentFeeAmounts, setHostelStudentFeeAmounts] = useState({});
const [hostelFeesByClass, setHostelFeesByClass] = useState({});
const [pendingFeesData, setPendingFeesData] = useState({});
const [idFeesData, setIdFeesData] = useState({});
 const [busFeeByClass, setBusFeeByClass] = useState({});
 const [feeTypeDiscounts, setFeeTypeDiscounts] = useState({});
 const [hostelFeeDiscounts, setHostelFeeDiscounts] = useState({});

  // Parse classDiv
  let formattedClassDiv = ['-'];
  try {
    const parsed = JSON.parse(classDivRaw);
    if (typeof parsed === 'object' && parsed !== null) {
      formattedClassDiv = Object.keys(parsed).map((className) => {
        const divisions = parsed[className];
        const divisionList = Object.keys(divisions)
          .filter((div) => divisions[div] === true)
          .join(',');
        return `${className}:${divisionList}`;
      });
    }
  } catch (e) {
    formattedClassDiv = ['-'];
  }

  // Function to count active students for a specific class
  const getStudentCountForClass = (className) => {
    if (!studentData || typeof studentData !== 'object') return 0;
    return Object.values(studentData).filter(
      (student) =>
        student?.currentClass?.toLowerCase().trim() === className?.toLowerCase().trim() &&
        student?.isActive !== false
    ).length;
  };

  // IndexedDB setup
  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

     request.onupgradeneeded = (event) => {
  const db = event.target.result;
  if (!db.objectStoreNames.contains('studentData')) {
    db.createObjectStore('studentData', { keyPath: 'serialNo' });
  }
  if (!db.objectStoreNames.contains('studentFee')) {
    db.createObjectStore('studentFee', { keyPath: 'serialNo' });
  }
  if (!db.objectStoreNames.contains('defaultSettings')) {
    db.createObjectStore('defaultSettings', { keyPath: 'id' });
  }
  if (!db.objectStoreNames.contains('fees')) {
    db.createObjectStore('fees', { keyPath: 'id' });
  }
  if (!db.objectStoreNames.contains('hostel')) {
    db.createObjectStore('hostel', { keyPath: 'id' });
  }
  if (!db.objectStoreNames.contains('pendingFees')) {
    db.createObjectStore('pendingFees', { keyPath: 'id' });
  }
  if (!db.objectStoreNames.contains('busStudents')) {
    db.createObjectStore('busStudents', { keyPath: 'id' });
  }
  if (!db.objectStoreNames.contains('IdFees')) {
    db.createObjectStore('IdFees', { keyPath: 'id' });
  }
};
    });
  };

  // Fetch academic year from IndexedDB
  useEffect(() => {
    if (!udiseNumber) return;

    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;
          if (defaultSetting && defaultSetting.defaultYear) {
            setAcademicYear(defaultSetting.defaultYear);
          } else {
            console.warn("No default year found in settings");
            const currentYear = new Date().getFullYear();
            const nextYear = currentYear + 1;
            setAcademicYear(`${currentYear}-${nextYear.toString().slice(2)}`);
          }
        };


        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error accessing IndexedDB:', error);
      }
    };

    fetchDefaultYear();
  }, [udiseNumber]);

  // Fetch studentData from IndexedDB
 const fetchStudentData = async () => {
  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['studentData'], 'readonly');
    const objectStore = transaction.objectStore('studentData');
    const request = objectStore.getAll();

    request.onsuccess = (event) => {
      const studentDataArray = event.target.result;
      console.log("Raw studentData in fetchStudentData:", studentDataArray);
      const studentDataObj = {};
      studentDataArray.forEach((student) => {
        studentDataObj[student.serialNo] = student;
      });
      console.log("Populated studentDataObj:", studentDataObj);
      setStudentData(studentDataObj);
    };

    request.onerror = (event) => {
      console.error("Error fetching student data:", event.target.error);
    };
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
  }
};

const fetchIdFees = async () => {
  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['IdFees'], 'readonly');
    const objectStore = transaction.objectStore('IdFees');
    const request = objectStore.getAll();

    request.onsuccess = (event) => {
      const idFeesArray = event.target.result;
      const idFeesObj = {};
      
      idFeesArray.forEach((idFee) => {
        if (idFee.value && typeof idFee.value === 'object') {
          Object.entries(idFee.value).forEach(([serialNo, amount]) => {
            idFeesObj[serialNo] = parseFloat(amount) || 0;
          });
        }
      });
      
      setIdFeesData(idFeesObj);
      console.log("ID fees data:", idFeesObj);
    };

    request.onerror = (event) => {
      console.error("Error fetching ID fees:", event.target.error);
    };
  } catch (error) {
    console.error('Error accessing IndexedDB for ID fees:', error);
  }
};

const fetchHostelData = async () => {
  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['hostel'], 'readonly');
    const hostelStore = transaction.objectStore('hostel');
    const hostelRequest = hostelStore.getAll();

    hostelRequest.onsuccess = async () => {
      const hostelData = hostelRequest.result;
      console.log("Raw hostel data:", hostelData);

      // Debug: Log the current studentData state
      console.log("Current studentData state:", studentData);

      const hostelFees = {};
      const hostelStudentFeeAmounts = {};
      const hostelDiscounts = {}; // New object to track hostel discounts

      for (const hostelEntry of hostelData) {
        if (hostelEntry.value && typeof hostelEntry.value === 'object') {
          for (const [serialNo, feeAmount] of Object.entries(hostelEntry.value)) {
            console.log(`Serial Number: ${serialNo}, Hostel Fee: ${feeAmount}`);

            const student = studentData[serialNo] || studentData[Number(serialNo)] || studentData[String(serialNo)];

            if (student && student.currentClass) {
              const className = student.currentClass.toLowerCase().trim();

              // Check for discounts in studentFeeData
              const studentFee = studentFeeData[serialNo];
              let discountAmount = 0;
              
              if (studentFee) {
                const lastInvoiceNo = studentFee.lastInvoiceNo || 
                  Math.max(...Object.keys(studentFee).filter(k => k !== 'lastInvoiceNo' && studentFee[k] !== null).map(Number));
                
                if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
                  const feeDetails = studentFee[lastInvoiceNo]['hostel-fee'] || studentFee[lastInvoiceNo]['hostel-fee'];
                  if (feeDetails && feeDetails.discountAmount) {
                    discountAmount = parseFloat(feeDetails.discountAmount) || 0;
                    console.log(`Found hostel discount for ${serialNo}: ₹${discountAmount}`);
                    
                    // Track discounts by class
                    if (!hostelDiscounts[className]) {
                      hostelDiscounts[className] = 0;
                    }
                    hostelDiscounts[className] += discountAmount;
                  }
                }
              }

              if (!hostelFees[className]) {
                hostelFees[className] = [];
              }

              const feeEntry = {
                serialNo,
                feeAmount: parseFloat(feeAmount) || 0,
                discountAmount, // Include discount in the fee entry
                feeType: 'hostel',
                className,
              };

              hostelFees[className].push(feeEntry);
              hostelStudentFeeAmounts[serialNo] = feeEntry;
            }
          }
        }
      }

      console.log("Hostel fees by class with discounts:", hostelFees);
      console.log("Hostel discounts by class:", hostelDiscounts);

      setHostelFeesByClass(hostelFees);
      setHostelStudentFeeAmounts(hostelStudentFeeAmounts);
      // Update classFeeTypeDiscounts to include hostel discounts
      setClassFeeTypeDiscounts(prev => {
        const updated = {...prev};
        Object.entries(hostelDiscounts).forEach(([className, discount]) => {
          if (!updated[className]) {
            updated[className] = {};
          }
          updated[className]['hostel'] = discount;
        });
        console.log("Updated classFeeTypeDiscounts with hostel:", updated);
        return updated;
      });

      setIsLoading(false);
    };

    hostelRequest.onerror = (event) => {
      console.error("Error fetching hostel data:", event.target.error);
      setIsLoading(false);
    };
  } catch (error) {
    console.error('Error accessing IndexedDB for hostel data:', error);
    setIsLoading(false);
  }
};

const fetchPendingFees = async () => {
  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['pendingFees'], 'readonly');
    const objectStore = transaction.objectStore('pendingFees');
    const request = objectStore.getAll();

    request.onsuccess = (event) => {
      const pendingFeesArray = event.target.result;
      const pendingFeesObj = {};
      
      pendingFeesArray.forEach((pendingFee) => {
        if (pendingFee.value && typeof pendingFee.value === 'object') {
          Object.entries(pendingFee.value).forEach(([serialNo, amount]) => {
            pendingFeesObj[serialNo] = parseFloat(amount) || 0;
          });
        }
      });
      
      setPendingFeesData(pendingFeesObj);
      console.log("Pending fees data:", pendingFeesObj);
    };

    request.onerror = (event) => {
      console.error("Error fetching pending fees:", event.target.error);
    };
  } catch (error) {
    console.error('Error accessing IndexedDB for pending fees:', error);
  }
};

const fetchBusFeeData = async () => {
  try {
    const db = await openIndexedDB();
    
    // Check if busStudents object store exists
    if (!db.objectStoreNames.contains('busStudents')) {
      console.warn("busStudents object store not found in database");
      setBusFeeByClass({});
      return;
    }

    const transaction = db.transaction(['busStudents', 'fees'], 'readonly');
    const busStudentStore = transaction.objectStore('busStudents');
    const feeStore = transaction.objectStore('fees');

    const busStudentRequest = busStudentStore.getAll();
    const feeRequest = feeStore.getAll();

    const [busStudents, fees] = await Promise.all([
      new Promise((resolve, reject) => {
        busStudentRequest.onsuccess = () => resolve(busStudentRequest.result);
        busStudentRequest.onerror = (e) => {
          console.error("Error fetching bus students:", e.target.error);
          resolve([]); // Return empty array instead of rejecting
        };
      }),
      new Promise((resolve, reject) => {
        feeRequest.onsuccess = () => resolve(feeRequest.result);
        feeRequest.onerror = (e) => {
          console.error("Error fetching fees:", e.target.error);
          resolve([]); // Return empty array instead of rejecting
        };
      }),
    ]);

    let busFeeAmount = 0;
    const currentYearFeeRecord = fees.find((fee) => fee.key === academicYear);
    if (
      currentYearFeeRecord?.data?.root?.feetype?.toLowerCase().trim() === 'bus fee' &&
      currentYearFeeRecord?.data?.root?.amount
    ) {
      busFeeAmount = parseFloat(currentYearFeeRecord.data.root.amount) || 0;
    }

    let busFeeType = 'bus fee';
    if (currentYearFeeRecord?.value) {
      for (const [feeType, feeDetails] of Object.entries(currentYearFeeRecord.value)) {
        if (feeDetails?.feetype?.toLowerCase().trim() === 'bus fee') {
          busFeeType = feeDetails.feetype;
          break;
        }
      }
    }

    const busFees = {};
    busStudents.forEach((entry) => {
      if (entry.studentSerialNo?.serialNumber === true) {
        const serialNo = entry.id;
        const student = studentData[serialNo];
        if (student?.currentClass) {
          const className = student.currentClass.toLowerCase().trim();
          if (!busFees[className]) {
            busFees[className] = {
              feeType: busFeeType,
              amount: 0,
            };
          }
          busFees[className].amount += busFeeAmount;
        }
      }
    });

    setBusFeeByClass(busFees);
    console.log('Bus fees by class:', busFees);
  } catch (error) {
    console.error('Error fetching bus fee data:', error);
    setBusFeeByClass({});
  }
};

  // Fetch fee data from IndexedDB
const fetchFeeData = async () => {
  if (!academicYear || !showObjectColumn || !udiseNumber) {
    console.log("Skipping fetchFeeData - missing required data:", {
      academicYear,
      showObjectColumn,
      udiseNumber,
    });
    return;
  }

  try {
    const db = await openIndexedDB();
    const transaction = db.transaction(['fees'], 'readonly');
    const objectStore = transaction.objectStore('fees');
    const request = objectStore.getAll();

    request.onsuccess = (event) => {
      const feeDataArray = event.target.result;
      console.log("Raw fee data from IndexedDB:", feeDataArray);

      if (!feeDataArray || feeDataArray.length === 0) {
        console.warn("No fee data found in IndexedDB");
        setFeeData([]);
        return;
      }

      const currentYearFeeRecord = feeDataArray.find(fee => fee.key === academicYear);
      console.log("currentYearFeeRecord", currentYearFeeRecord);

      if (!currentYearFeeRecord) {
        console.warn(`No fee data found for academic year ${academicYear}`);
        setFeeData([]);
        return;
      }

      console.log("Current year fee record:", currentYearFeeRecord);

      const feeMap = {};
      for (const [feeType, feeDetails] of Object.entries(currentYearFeeRecord.value)) {
        if (feeDetails && typeof feeDetails === 'object') {
          const baseFeeType = getBaseFeetype(feeDetails.feetype || feeType).toLowerCase().trim();
          console.log(`Processing fee type ${feeType} -> normalized: ${baseFeeType}`, feeDetails);

          if (!feeMap[baseFeeType]) {
            feeMap[baseFeeType] = {
              feeName: baseFeeType,
              classType: feeDetails.classType || '',
              totalFee: parseFloat(feeDetails.amount) || 0,
              receivedFee: 0,
              classSpecificReceived: {},
              classSpecificDiscount: {},
              classSpecificPending: {},
              rawData: feeDetails,
            };
          } else {
            feeMap[baseFeeType].totalFee += parseFloat(feeDetails.amount) || 0;
            if (feeDetails.classType && feeMap[baseFeeType].classType !== 'all') {
              feeMap[baseFeeType].classType = feeMap[baseFeeType].classType
                ? `${feeMap[baseFeeType].classType}, ${feeDetails.classType}`
                : feeDetails.classType;
            }
          }
        }
      }

      // Add bus fee data from student records
      const busFeeStudents = Object.values(studentData).filter(student => 
        student?.busFee === true && student?.isActive !== false
      );
      
      if (busFeeStudents.length > 0) {
        feeMap['bus fee'] = {
          feeName: 'bus fee',
          classType: 'all',
          totalFee: busFeeStudents.length * 1000, // Assuming 1000 is the bus fee amount
          receivedFee: 0,
          classSpecificReceived: {},
          classSpecificDiscount: {},
          classSpecificPending: {},
          rawData: { amount: 1000, feetype: 'bus fee' }
        };
      }

      const feeArray = Object.values(feeMap).map((fee, index) => ({
        id: index + 1,
        ...fee,
      }));

      setFeeData(feeArray);
      console.log("Processed feeArray:", feeArray);
    };

    request.onerror = (event) => {
      console.error("Error fetching fee data:", event.target.error);
    };
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
  }
};
// Fetch studentFee data from IndexedDB
const fetchStudentFeeData = async (year) => {
  if (!year || !udiseNumber) {
    console.warn("No academic year or udiseNumber provided, skipping fetchStudentFeeData");
    setIsLoading(false);
    return;
  }

  try {
    setIsLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}.json`
    );
    const studentFeeDataRaw = await response.json();

    if (!studentFeeDataRaw) {
      console.warn("No student fee data found in Firebase for the given year and udiseNumber");
      setIsLoading(false);
      return;
    }

    const discounts = {};
    const receivedAmounts = {};
    const feeTypeDiscountData = {};

    // Process each serialNo
    Object.entries(studentFeeDataRaw).forEach(([serialNo, invoices]) => {
      if (invoices && typeof invoices === 'object') {
        const lastInvoiceNo = invoices.lastinvoiceno || 
          Math.max(...Object.keys(invoices)
            .filter(k => k !== 'lastinvoiceno' && invoices[k] !== null)
            .map(Number));

        if (lastInvoiceNo && invoices[lastInvoiceNo]) {
          Object.entries(invoices[lastInvoiceNo]).forEach(([feeType, details]) => {
            const className = details.class?.trim() || studentData[serialNo]?.currentClass?.trim();
            if (!className) return;

            // Normalize fee type names to prevent duplicates
            let normalizedFeeType;
            if (feeType.toLowerCase().includes('bus')) {
              normalizedFeeType = 'bus fee';
            } else if (feeType.toLowerCase().includes('hostel')) {
              normalizedFeeType = 'hostel fee';
            } else if (feeType.toLowerCase().includes('pending')) {
              normalizedFeeType = 'pending fee';
            } else if (feeType.toLowerCase().includes('identity') || feeType.toLowerCase().includes('id')) {
              normalizedFeeType = 'identity fee';
            } else {
              normalizedFeeType = getBaseFeetype(feeType).toLowerCase().trim();
            }

            const received = parseFloat(details.beforePay) || 0;
            const discount = parseFloat(details.discountAmount) || 0;

            if (!receivedAmounts[className]) receivedAmounts[className] = {};
            receivedAmounts[className][normalizedFeeType] = (receivedAmounts[className][normalizedFeeType] || 0) + received;

            if (!discounts[className]) discounts[className] = {};
            discounts[className][normalizedFeeType] = (discounts[className][normalizedFeeType] || 0) + discount;

            if (!feeTypeDiscountData[serialNo]) feeTypeDiscountData[serialNo] = {};
            feeTypeDiscountData[serialNo][normalizedFeeType] = discount;
          });
        }
      }
    });

    setClassFeeTypeDiscounts(discounts);
    setClassFeeTypeReceived(receivedAmounts);
    setStudentFeeData(studentFeeDataRaw);
    setFeeTypeDiscounts(feeTypeDiscountData);
    setIsLoading(false);
  } catch (error) {
    console.error('Error fetching student fee data from Firebase:', error);
    setIsLoading(false);
  }
};


  useEffect(() => {
    if (!udiseNumber || !academicYear) {
       return;
    }
    fetchStudentFeeData(academicYear);
    fetchFeeData();
  }, [udiseNumber, academicYear, studentData]);

  const updateFeeData = (studentFeeData) => {
    setFeeData((prevFeeData) =>
      prevFeeData.map((feeItem) => {
        let totalReceived = 0;
        const classSpecificReceived = {};
        const classSpecificDiscount = {};
        const classSpecificPending = {};


        Object.entries(studentFeeData).forEach(([serialNo, invoices]) => {
          const student = studentData[serialNo];
          if (!student || student.isActive === false) {
         
            return;
          }

          const lastInvoiceNo = invoices.lastInvoiceNo ||
            Math.max(...Object.keys(invoices).filter(k => k !== 'lastInvoiceNo' && invoices[k] !== null).map(Number));

          if (!lastInvoiceNo || !invoices[lastInvoiceNo]) {
            
            return;
          }

         Object.entries(invoices[lastInvoiceNo]).forEach(([feeType, details]) => {
            const baseFeeType = getBaseFeetype(feeType).toLowerCase().trim();
            const feeItemName = feeItem.feeName.toLowerCase().trim();
            const invoiceClass = details.class?.toLowerCase().trim();
            const feeClassType = feeItem.classType?.toLowerCase().trim();

            if (
              details &&
              baseFeeType === feeItemName &&
              (invoiceClass === feeClassType || feeClassType === 'all')
            ) {
              const amount = parseFloat(details.beforePay || 0);
              const discount = parseFloat(details.discountAmount || 0);
              totalReceived += amount;

              if (invoiceClass) {
                classSpecificReceived[invoiceClass] = classSpecificReceived[invoiceClass] || {};
                classSpecificDiscount[invoiceClass] = classSpecificDiscount[invoiceClass] || {};

                classSpecificReceived[invoiceClass][baseFeeType] =
                  (classSpecificReceived[invoiceClass][baseFeeType] || 0) + amount;
                classSpecificDiscount[invoiceClass][baseFeeType] =
                  (classSpecificDiscount[invoiceClass][baseFeeType] || 0) + discount;

                const studentCount = getStudentCountForClass(invoiceClass);
                const finalAmount =
                  (feeItem.totalFee * studentCount) -
                  (classSpecificDiscount[invoiceClass][baseFeeType] || 0);
                classSpecificPending[invoiceClass] =
                  finalAmount - (classSpecificReceived[invoiceClass][baseFeeType] || 0);
              }
            } else {
             }
          });
        });

        console.log(`Updated feeItem ${feeItem.feeName}:`, {
          totalReceived,
          classSpecificReceived,
          classSpecificDiscount,
          classSpecificPending,
        });

        return {
          ...feeItem,
          receivedFee: totalReceived,
          classSpecificReceived,
          classSpecificDiscount,
          classSpecificPending,
        };
      })
    );
  };

  // Initial data fetching
 useEffect(() => {
    if (!udiseNumber) return;
    const fetchData = async () => {
      await fetchStudentData();
      await fetchHostelData();
      await fetchPendingFees();
      await fetchIdFees();
      await fetchBusFeeData();
    };
    fetchData();
  }, [udiseNumber]);

  useEffect(() => {
    if (!udiseNumber || !academicYear) return;
    fetchStudentFeeData(academicYear);
    fetchFeeData();
  }, [udiseNumber, academicYear, studentData]);

  const handleClassDivClick = (className, division) => {
    navigate(`/divisionwisefee/${className}/${division}`);
  };

  const handleClassClick = (className) => {
    setSelectedClass(selectedClass === className ? null : className);
  };

 const getBaseFeetype = (feetype) => {
  const lastIndex = feetype.lastIndexOf('-');
  const base = lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype;
  return base.toLowerCase().replace(/fee/i, 'fee').trim();
};

// Helper functions
const discountCellStyle = (amount) => ({
  padding: '6px 8px',
  border: '1px solid #e2e8f0',
  borderRadius: '4px',
  backgroundColor: '#ffffff',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  fontSize: '14px',
  color: amount > 0 ? '#ea580c' : '#64748b',
  textAlign: 'center',
});

const feeTypeLabelStyle = {
  fontSize: '10px',
  color: '#9ca3af',
  marginTop: '2px'
};

const totalDiscountStyle = {
  marginTop: '8px',
  paddingTop: '8px',
  borderTop: '1px solid #cbd5e1',
  fontWeight: '600',
  fontSize: '14px',
  color: '#ea580c'
};

const getPendingFeeDiscount = (serialNo) => {
  const studentFee = studentFeeData[serialNo];
  if (!studentFee) return 0;
  console.log("studentFee",studentFee);
  
  const lastInvoiceNo = studentFee.lastInvoiceNo || 
    Math.max(...Object.keys(studentFee).filter(k => k !== 'lastInvoiceNo' && studentFee[k] !== null).map(Number));
  
  if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
    const feeDetails = studentFee[lastInvoiceNo]['Pending Fee'] || studentFee[lastInvoiceNo]['Pending Fee'];
    return parseFloat(feeDetails?.discountAmount || 0);
  }
  return 0;
};

const getIdFeeDiscount = (serialNo) => {
  const studentFee = studentFeeData[serialNo];
  if (!studentFee) return 0;
  
  const lastInvoiceNo = studentFee.lastInvoiceNo || 
    Math.max(...Object.keys(studentFee).filter(k => k !== 'lastInvoiceNo' && studentFee[k] !== null).map(Number));
  
  if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
    const feeDetails = studentFee[lastInvoiceNo]['Identity Card Fee'] || studentFee[lastInvoiceNo]['Identity Card Fee'];
    return parseFloat(feeDetails?.discountAmount || 0);
  }
  return 0;
};

const calculateTotalDiscount = (classNameOnly, feesForClass) => {
  const classNameKey = classNameOnly.toLowerCase().trim();

  // Regular fees
  const regularFeesDiscount = feesForClass.reduce((sum, feeItem) => {
    const feeTypeKey = getBaseFeetype(feeItem.feeName).toLowerCase().trim();
    return sum + (classFeeTypeDiscounts[classNameKey]?.[feeTypeKey] || 0);
  }, 0);

  // Hostel fee
  const hostelDiscount = hostelFeesByClass[classNameKey]?.reduce((sum, entry) => {
    const studentFee = studentFeeData[entry.serialNo];
    if (studentFee) {
      const lastInvoiceNo =
        studentFee.lastinvoiceno ||
        Math.max(
          ...Object.keys(studentFee)
            .filter((k) => k !== 'lastinvoiceno' && studentFee[k] !== null)
            .map(Number)
        );

      if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
        const feeDetails =
          studentFee[lastInvoiceNo]['Hostel Fee'] || studentFee[lastInvoiceNo]['hostel fee'];
        return sum + (parseFloat(feeDetails?.discountAmount) || 0);
      }
    }
    return sum;
  }, 0) || 0;

  // Bus fee
  const busDiscount = Object.entries(studentFeeData).reduce((sum, [serialNo, invoices]) => {
    const student = studentData[serialNo];
    if (
      student?.currentClass?.toLowerCase().trim() === classNameKey &&
      student?.busFee === true &&
      student?.isActive !== false
    ) {
      const lastInvoiceNo =
        invoices.lastinvoiceno ||
        Math.max(
          ...Object.keys(invoices)
            .filter((k) => k !== 'lastinvoiceno' && invoices[k] !== null)
            .map(Number)
        );

      if (lastInvoiceNo && invoices[lastInvoiceNo]) {
        const feeDetails = invoices[lastInvoiceNo]['Bus Fee'] || invoices[lastInvoiceNo]['bus fee'];
        return sum + (parseFloat(feeDetails?.discountAmount) || 0);
      }
    }
    return sum;
  }, 0);

  // Pending fees
  const pendingDiscounts = Object.entries(pendingFeesData).reduce((sum, [serialNo, amount]) => {
    const student = studentData[serialNo];
    if (student?.currentClass?.toLowerCase().trim() === classNameKey) {
      const studentFee = studentFeeData[serialNo];
      if (studentFee) {
        const lastInvoiceNo =
          studentFee.lastinvoiceno ||
          Math.max(
            ...Object.keys(studentFee)
              .filter((k) => k !== 'lastinvoiceno' && studentFee[k] !== null)
              .map(Number)
          );

        if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
          const feeDetails =
            studentFee[lastInvoiceNo]['Pending Fee'] || studentFee[lastInvoiceNo]['pending fee'];
          return sum + (parseFloat(feeDetails?.discountAmount) || 0);
        }
      }
    }
    return sum;
  }, 0);

  // ID fees
  const idFeeDiscounts = Object.entries(idFeesData).reduce((sum, [serialNo, amount]) => {
    const student = studentData[serialNo];
    if (student?.currentClass?.toLowerCase().trim() === classNameKey) {
      const studentFee = studentFeeData[serialNo];
      if (studentFee) {
        const lastInvoiceNo =
          studentFee.lastinvoiceno ||
          Math.max(
            ...Object.keys(studentFee)
              .filter((k) => k !== 'lastinvoiceno' && studentFee[k] !== null)
              .map(Number)
          );

        if (lastInvoiceNo && studentFee[lastInvoiceNo]) {
          const feeDetails =
            studentFee[lastInvoiceNo]['Identity Card Fee'] ||
            studentFee[lastInvoiceNo]['identity card fee'];
          return sum + (parseFloat(feeDetails?.discountAmount) || 0);
        }
      }
    }
    return sum;
  }, 0);

  return regularFeesDiscount + hostelDiscount + busDiscount + pendingDiscounts + idFeeDiscounts;
};

  if (!showObjectColumn) {
    return null;
  }

  return (
    <div className='main-content-of-page'>
      <div style={{
        background: 'linear-gradient(to bottom right, rgba(0, 123, 255, 0.3), rgba(255, 255, 255, 1))',
        minHeight: '100vh',
        fontFamily: "'Inter', sans-serif",
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '24px',
        }}>
          {/* Header Section */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '32px',
            paddingBottom: '16px',
            borderBottom: '1px solid #e2e8f0'
          }}>
            <div>
              <h1 style={{
                fontSize: '28px',
                fontWeight: '700',
                color: '#1e293b',
                margin: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <span style={{
                  display: 'inline-block',
                  width: '40px',
                  height: '40px',
                  backgroundColor: '#3b82f6',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  color: 'white',
                  fontSize: '20px'
                }}>₹</span>
                Fee Dashboard
              </h1>
              <p style={{
                color: '#64748b',
                marginTop: '8px',
                fontSize: '14px'
              }}>Overview of all fee collections and pending amounts</p>
            </div>

            {department && (
              <div style={{
                backgroundColor: '#e0f2fe',
                color: '#0369a1',
                padding: '8px 16px',
                borderRadius: '20px',
                fontWeight: '600',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="#0369a1"/>
                  <path d="M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3  righteousness: 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z" fill="#0369a1"/>
                  <path d="M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z" fill="#0369a1"/>
                </svg>
                {department}
              </div>
            )}
          </div>

          {/* Academic Year Indicator */}
          {academicYear && (
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: '#f0fdf4',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '24px',
              fontSize: '14px',
              fontWeight: '500',
              width: '100%'
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                color: '#166534'
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#166534" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Academic Year: {academicYear}
              </div>
              <button
                style={{
                  backgroundColor: '#3b82f6',
                  color: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onClick={() => navigate('/atm1')}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                Pay Fee
              </button>
            </div>
          )}

          {/* Dashboard Stats */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
            gap: '16px',
            marginBottom: '24px'
          }}>
            <div style={{
              backgroundColor: '#bed5fa',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              borderLeft: '4px solid #3b82f6'
            }}>
              <div style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Total Classes</div>
              <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>{formattedClassDiv.length}</div>
            </div>

            <div style={{
              backgroundColor: '#c6f5e5',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              borderLeft: '4px solid #10b981'
            }}>
              <div style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Total Students</div>
              <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>
                {Object.values(studentData).filter(s => s?.isActive !== false && s !== null).length}
              </div>
            </div>

           <div style={{
  backgroundColor: '#e9ec8d',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  borderLeft: '4px solid #f1fa05'
}}>
  <div style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Total Fee</div>
  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>
    ₹{formattedClassDiv
      .reduce((total, classDiv) => {
        const [classNameOnly] = classDiv.split(':');
        const studentCount = getStudentCountForClass(classNameOnly);
        const feesForClass = feeData.filter(
          (feeItem) =>
            (feeItem.classType?.toLowerCase().trim() === classNameOnly.toLowerCase().trim() ||
             feeItem.classType?.toLowerCase().trim() === 'all')
        );

        // Calculate regular fees
        const classTotal = feesForClass.reduce(
          (sum, feeItem) =>
            sum + (feeItem.totalFee * studentCount),
          0
        );

        // Add hostel fees
        const hostelFeesForClass = hostelFeesByClass[classNameOnly.toLowerCase().trim()] || [];
        const totalHostelFee = hostelFeesForClass.reduce((sum, entry) => sum + (parseFloat(entry.feeAmount) || 0), 0);

        // Add bus fees
        const busFeeForClass = busFeeByClass[classNameOnly.toLowerCase().trim()]?.amount || 0;

        // Add pending fees
        const pendingFeesForClass = Object.entries(pendingFeesData).reduce((sum, [serialNo, amount]) => {
          const student = studentData[serialNo];
          if (student && student.currentClass?.toLowerCase().trim() === classNameOnly.toLowerCase().trim()) {
            return sum + amount;
          }
          return sum;
        }, 0);

        // Add ID fees
        const idFeesForClass = Object.entries(idFeesData).reduce((sum, [serialNo, amount]) => {
          const student = studentData[serialNo];
          if (student && student.currentClass?.toLowerCase().trim() === classNameOnly.toLowerCase().trim()) {
            return sum + amount;
          }
          return sum;
        }, 0);

        return total + classTotal + totalHostelFee + busFeeForClass + pendingFeesForClass + idFeesForClass;
      }, 0)
      .toFixed(2)}
  </div>
</div>

            <div style={{
  backgroundColor: '#fae9c3',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  borderLeft: '4px solid #f59e0b'
}}>
  <div style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Total Fee Collected</div>
  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>
    ₹{formattedClassDiv
      .reduce((total, classDiv) => {
        const [classNameOnly] = classDiv.split(':');
        const classReceived = Object.values(classFeeTypeReceived[classNameOnly.toLowerCase().trim()] || {}).reduce((sum, val) => sum + val, 0);
        return total + classReceived;
      }, 0)
      .toFixed(2)}
  </div>
</div>

          <div style={{
  backgroundColor: '#f2c0bb',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  borderLeft: '4px solid #ef4444'
}}>
  <div style={{ color: 'black', fontSize: '14px', marginBottom: '8px' }}>Total Pending</div>
  <div style={{ fontSize: '24px', fontWeight: '700', color: '#1e293b' }}>
    ₹{formattedClassDiv
      .reduce((total, classDiv) => {
        const [classNameOnly] = classDiv.split(':');
        const classNameKey = classNameOnly.toLowerCase().trim();
        const studentCount = getStudentCountForClass(classNameOnly);
        const feesForClass = feeData.filter(
          (feeItem) =>
            (feeItem.classType?.toLowerCase().trim() === classNameKey ||
             feeItem.classType?.toLowerCase().trim() === 'all')
        );

        // Calculate regular fees pending
        const classTotalPending = feesForClass.reduce((sum, feeItem) => {
          const feeTypeKey = getBaseFeetype(feeItem.feeName).toLowerCase().trim();
          const totalFee = feeItem.totalFee * studentCount;
          const discount = classFeeTypeDiscounts[classNameKey]?.[feeTypeKey] || 0;
          const finalAmount = totalFee - discount;
          const receivedAmount = classFeeTypeReceived[classNameKey]?.[feeTypeKey] || 0;
          return sum + (finalAmount - receivedAmount);
        }, 0);

        // Calculate hostel fees pending
        const hostelFeesForClass = hostelFeesByClass[classNameKey] || [];
        const totalHostelFee = hostelFeesForClass.reduce((sum, entry) => sum + (parseFloat(entry.feeAmount) || 0), 0);
        const hostelDiscount = classFeeTypeDiscounts[classNameKey]?.['hostel'] || 0;
        const hostelReceived = classFeeTypeReceived[classNameKey]?.['hostel'] || 0;
        const totalHostelPending = totalHostelFee - hostelDiscount - hostelReceived;

        // Calculate bus fees pending
        const busFeeForClass = busFeeByClass[classNameKey]?.amount || 0;
        const busDiscount = classFeeTypeDiscounts[classNameKey]?.['bus fee'] || 0;
        const busReceived = classFeeTypeReceived[classNameKey]?.['bus fee'] || 0;
        const busPending = busFeeForClass - busDiscount - busReceived;

        // Calculate pending fees
        const pendingFeesPending = Object.entries(pendingFeesData).reduce((sum, [serialNo, amount]) => {
          const student = studentData[serialNo];
          if (student && student.currentClass?.toLowerCase().trim() === classNameKey) {
            const pendingDiscount = getPendingFeeDiscount(serialNo);
            const finalAmount = amount - pendingDiscount;
            const receivedAmount = classFeeTypeReceived[classNameKey]?.['pending fee'] || 0;
            return sum + (finalAmount - receivedAmount);
          }
          return sum;
        }, 0);

        // Calculate ID fees pending
        const idFeesPending = Object.entries(idFeesData).reduce((sum, [serialNo, amount]) => {
          const student = studentData[serialNo];
          if (student && student.currentClass?.toLowerCase().trim() === classNameKey) {
            const idDiscount = getIdFeeDiscount(serialNo);
            const finalAmount = amount - idDiscount;
            const receivedAmount = classFeeTypeReceived[classNameKey]?.['identity fee'] || 0;
            return sum + (finalAmount - receivedAmount);
          }
          return sum;
        }, 0);

        return total + classTotalPending + totalHostelPending + busPending + pendingFeesPending + idFeesPending;
      }, 0)
      .toFixed(2)}
  </div>
</div>
          </div>

          {/* Main Table */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
            marginBottom: '32px'
          }}>
            {isLoading ? (
              <div style={{
                padding: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#64748b'
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', animation: 'spin 1s linear infinite' }}>
                  <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                  <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h drifting,1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" fill="#3b82f6"/>
                </svg>
                Loading fee data...
              </div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  minWidth: '800px'
                }}>
                  <thead style={{
                    backgroundColor: '#f1f5f9',
                    borderBottom: '1px solid #e2e8f0'
                  }}>
                    <tr>
                      {['Class', 'Students', 'Fee Type', 'Total Fee', 'Discount', 'Final Amount', 'Received', 'Pending'].map((header, idx) => (
                        <th key={idx} style={{
                          padding: '16px 12px',
                          textAlign: 'center',
                          fontSize: '13px',
                          fontWeight: '600',
                          color: '#475569',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          whiteSpace: 'nowrap',
                          backgroundColor: '#004d99',
                          color: 'white'
                        }}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

           <tbody>
  {formattedClassDiv.map((classDiv, idx) => {
    const [classNameOnly, divisions] = classDiv.split(':');
    const divList = divisions ? divisions.split(',') : [];
    const feesForClass = feeData.filter(
      (feeItem) =>
        feeItem.classType?.toLowerCase().trim() === classNameOnly?.toLowerCase().trim() ||
        feeItem.classType?.toLowerCase().trim() === 'all'
    );
    const isExpanded = expandedClasses[classNameOnly];

    // Check if the class has hostel fees and calculate total hostel fee
    const hostelFeesForClass = hostelFeesByClass[classNameOnly.toLowerCase().trim()] || [];
    const hasHostelFee = hostelFeesForClass.length > 0;
    const totalHostelFee = hostelFeesForClass.reduce((sum, entry) => sum + (parseFloat(entry.feeAmount) || 0), 0);

    // Get bus fee for this class
    const busFeeForClass = busFeeByClass[classNameOnly.toLowerCase().trim()]?.amount || 0;
    const hasBusFee = busFeeForClass > 0;

    // Get pending and ID fees for this class
    const pendingFeesForClass = Object.entries(pendingFeesData).filter(
      ([serialNo, _]) => {
        const student = studentData[serialNo];
        return student && student.currentClass?.toLowerCase().trim() === classNameOnly.toLowerCase().trim();
      }
    );
    const idFeesForClass = Object.entries(idFeesData).filter(
      ([serialNo, _]) => {
        const student = studentData[serialNo];
        return student && student.currentClass?.toLowerCase().trim() === classNameOnly.toLowerCase().trim();
      }
    );

    return (
      <React.Fragment key={`${classDiv}`}>
        <tr
          style={{
            backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderBottom: '1px solid #f1f5f9',
            transition: 'background-color 0.2s',
          }}
        >
          {/* Class Column */}
          <td
            style={{
              padding: '16px 12px',
              fontWeight: '500',
              color: '#1e293b',
              verticalAlign: 'middle',
              textAlign: 'center',
            }}
          >
            <div
              onClick={() => handleClassClick(classNameOnly)}
              style={{
                fontWeight: '600',
                padding: '2px 6px',
                borderRadius: '4px',
                cursor: 'pointer',
                color: '#1e40af',
                display: 'inline-block',
              }}
            >
              {classNameOnly}
              {selectedClass === classNameOnly && (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '8px',
                  }}
                >
                  {divList.map((div, i) => (
                    <div
                      key={i}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClassDivClick(classNameOnly, div);
                      }}
                      style={{
                        color: '#1e40af',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        cursor: 'pointer',
                      }}
                    >
                      {div}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </td>

          {/* Students Column */}
          <td
            style={{
              padding: '16px 12px',
              color: '#1e293b',
              verticalAlign: 'middle',
              textAlign: 'center',
            }}
          >
            <div style={{ fontSize: '14px' }}>
              {getStudentCountForClass(classNameOnly)}
            </div>
          </td>

          {/* Fee Type Column */}
          <td
            style={{
              padding: '16px 12px',
              color: '#1e293b',
              verticalAlign: 'middle',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                cursor: 'pointer',
                padding: '6px 8px',
                borderRadius: '4px',
                backgroundColor: isExpanded ? '#e0f2fe' : '#f8fafc',
                transition: 'background-color 0.2s',
                display: 'inline-block',
              }}
              onClick={() =>
                setExpandedClasses((prev) => ({
                  ...prev,
                  [classNameOnly]: !prev[classNameOnly],
                }))
              }
            >
              {isExpanded ? (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '8px',
                    justifyContent: 'center',
                  }}
                >
                  {feesForClass.map((feeItem, index) => (
                    <div
                      key={feeItem.id}
                      style={{
                        padding: '6px 8px',
                        borderRadius: '4px',
                        backgroundColor: '#f8fafc',
                        transition: 'background-color 0.2s',
                        fontSize: '12px',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#e0f2fe')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = '#f8fafc')
                      }
                    >
                      {feeItem.feeName}
                    </div>
                  ))}
                  {hasHostelFee && (
                    <div
                      style={{
                        padding: '6px 8px',
                        borderRadius: '4px',
                        backgroundColor: '#f8fafc',
                        transition: 'background-color 0.2s',
                        fontSize: '12px',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#e0f2fe')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = '#f8fafc')
                      }
                    >
                      Hostel Fee
                    </div>
                  )}
                  {hasBusFee && (
                    <div
                      style={{
                        padding: '6px 8px',
                        borderRadius: '4px',
                        backgroundColor: '#f8fafc',
                        transition: 'background-color 0.2s',
                        fontSize: '12px',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#e0f2fe')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = '#f8fafc')
                      }
                    >
                      Bus Fee
                    </div>
                  )}
                  {pendingFeesForClass.map(([serialNo, _], i) => (
                    <div
                      key={`pending-${serialNo}`}
                      style={{
                        padding: '6px 8px',
                        borderRadius: '4px',
                        backgroundColor: '#f8fafc',
                        transition: 'background-color 0.2s',
                        fontSize: '12px',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#e0f2fe')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = '#f8fafc')
                      }
                    >
                      Pending Fee 
                    </div>
                  ))}
                  {idFeesForClass.map(([serialNo, _], i) => (
                    <div
                      key={`idfee-${serialNo}`}
                      style={{
                        padding: '6px 8px',
                        borderRadius: '4px',
                        backgroundColor: '#f8fafc',
                        transition: 'background-color 0.2s',
                        fontSize: '12px',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = '#e0f2fe')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = '#f8fafc')
                      }
                    >
                      Identity Fee 
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ fontWeight: '600', color: '#1e40af' }}>
                  {feesForClass.length +
                    (hasHostelFee ? 1 : 0) +
                    (hasBusFee ? 1 : 0) +
                    pendingFeesForClass.length +
                    idFeesForClass.length}{' '}
                  Fee Types
                </div>
              )}
            </div>
          </td>

          {/* Total Fee Column */}
         <td
  style={{
    padding: '16px 12px',
    color: '#1e293b',
    verticalAlign: 'middle',
    textAlign: 'center',
  }}
>
  <div
    style={{
      cursor: 'pointer',
      padding: '6px 8px',
      borderRadius: '4px',
      backgroundColor: expandedClasses[`total_${classNameOnly}`] || isExpanded ? '#e0f2fe' : '#f8fafc',
      transition: 'background-color 0.2s',
      display: 'inline-block',
    }}
    onClick={() =>
      setExpandedClasses((prev) => ({
        ...prev,
        [`total_${classNameOnly}`]: !prev[`total_${classNameOnly}`],
      }))
    }
  >
    {expandedClasses[`total_${classNameOnly}`] || isExpanded ? (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        {feesForClass.map((feeItem, index) => (
          <div
            key={feeItem.id}
            style={{
              padding: '6px 8px',
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span>{feeItem.feeName}:</span>
            <span>
              ₹{feeItem.feeName.toLowerCase().trim() === 'bus fee'
                ? (Object.values(studentData).filter(s => s?.busFee === true && s?.isActive !== false).length * feeItem.totalFee).toFixed(2)
                : (feeItem.totalFee * getStudentCountForClass(classNameOnly)).toFixed(2)}
            </span>
          </div>
        ))}
        {hasHostelFee && (
          <div
            style={{
              padding: '6px 8px',
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span>Hostel Fee:</span>
            <span>₹{totalHostelFee.toFixed(2)}</span>
          </div>
        )}
        {hasBusFee && (
          <div
            style={{
              padding: '6px 8px',
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span>Bus Fee:</span>
            <span>₹{busFeeForClass.toFixed(2)}</span>
          </div>
        )}
        {pendingFeesForClass.map(([serialNo, amount], i) => (
          <div
            key={`pending-total-${serialNo}`}
            style={{
              padding: '6px 8px',
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span>Pending Fee : </span>
            <span>₹{amount.toFixed(2)}</span>
          </div>
        ))}
        {idFeesForClass.map(([serialNo, amount], i) => (
          <div
            key={`idfee-total-${serialNo}`}
            style={{
              padding: '6px 8px',
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <span>Identity Fee :</span>
            <span>₹{amount.toFixed(2)}</span>
          </div>
        ))}
      </div>
    ) : (
      <div style={{ fontWeight: '600', fontSize: '14px' }}>
        ₹{(
          feesForClass.reduce(
            (sum, feeItem) =>
              sum + feeItem.totalFee * getStudentCountForClass(classNameOnly),
            0
          ) +
          totalHostelFee +
          busFeeForClass +
          pendingFeesForClass.reduce((sum, [, amount]) => sum + amount, 0) +
          idFeesForClass.reduce((sum, [, amount]) => sum + amount, 0)
        ).toFixed(2)}
      </div>
    )}
  </div>
</td>

{/* Discount Column */}
<td
  style={{
    padding: '16px 12px',
    color: '#1e293b',
    verticalAlign: 'middle',
    textAlign: 'center',
  }}
>
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {feesForClass.map((feeItem) => {
      const feeTypeKey = getBaseFeetype(feeItem.feeName).toLowerCase().trim();
      const totalDiscount = classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.[feeTypeKey] || 0;

      return (
        <div
          key={feeItem.id}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: totalDiscount > 0 ? '#ea580c' : '#64748b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>{feeItem.feeName}:</span>
          <span>₹{totalDiscount.toFixed(2)}</span>
        </div>
      );
    })}
    {hasHostelFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          color: (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) > 0 ? '#ea580c' : '#64748b',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Hostel Fee:</span>
        <span>₹{(classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0).toFixed(2)}</span>
      </div>
    )}
    {hasBusFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          color: (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) > 0 ? '#ea580c' : '#64748b',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Bus Fee:</span>
        <span>₹{(classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0).toFixed(2)}</span>
      </div>
    )}
    {pendingFeesForClass.map(([serialNo, _], i) => {
      const pendingDiscount = getPendingFeeDiscount(serialNo);
      return (
        <div
          key={`pending-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: pendingDiscount > 0 ? '#ea580c' : '#64748b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Pending Fee :</span>
          <span>₹{pendingDiscount.toFixed(2)}</span>
        </div>
      );
    })}
    {idFeesForClass.map(([serialNo, _], i) => {
      const idDiscount = getIdFeeDiscount(serialNo);
      return (
        <div
          key={`id-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: idDiscount > 0 ? '#ea580c' : '#64748b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Identity Fee :</span>
          <span>₹{idDiscount.toFixed(2)}</span>
        </div>
      );
    })}
  </div>
</td>

{/* Final Amount Column */}
<td
  style={{
    padding: '16px 12px',
    color: '#1e293b',
    verticalAlign: 'middle',
    textAlign: 'center',
  }}
>
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {feesForClass.map((feeItem) => {
      const studentCount = getStudentCountForClass(classNameOnly);
      const feeTypeKey = getBaseFeetype(feeItem.feeName).toLowerCase().trim();
      const totalFee = feeItem.totalFee * studentCount;
      const discount = classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.[feeTypeKey] || 0;
      const finalAmount = totalFee - discount;

      return (
        <div
          key={feeItem.id}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            fontWeight: '600',
            color: finalAmount < 0 ? '#dc2626' : '#1e293b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>{feeItem.feeName}:</span>
          <span>₹{finalAmount.toFixed(2)}</span>
        </div>
      );
    })}
    {hasHostelFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          fontWeight: '600',
          color: (totalHostelFee - (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0)) < 0 ? '#dc2626' : '#1e293b',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Hostel Fee:</span>
        <span>₹{(totalHostelFee - (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0)).toFixed(2)}</span>
      </div>
    )}
    {hasBusFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          fontWeight: '600',
          color: (busFeeForClass - (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0)) < 0 ? '#dc2626' : '#1e293b',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Bus Fee:</span>
        <span>₹{(busFeeForClass - (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0)).toFixed(2)}</span>
      </div>
    )}
    {pendingFeesForClass.map(([serialNo, amount], i) => {
      const pendingDiscount = getPendingFeeDiscount(serialNo);
      return (
        <div
          key={`pending-final-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Pending Fee :</span>
          <span>₹{(amount - pendingDiscount).toFixed(2)}</span>
        </div>
      );
    })}
    {idFeesForClass.map(([serialNo, amount], i) => {
      const idDiscount = getIdFeeDiscount(serialNo);
      return (
        <div
          key={`idfee-final-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Identity Fee :</span>
          <span>₹{(amount - idDiscount).toFixed(2)}</span>
        </div>
      );
    })}
  </div>
</td>

{/* Received Column */}
<td
  style={{
    padding: '16px 12px',
    color: '#1e293b',
    verticalAlign: 'middle',
    textAlign: 'center',
  }}
>
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {Array.from(new Set(
      Object.entries(studentFeeData).flatMap(([serialNo, invoices]) => {
        const student = studentData[serialNo];
        if (!student || student.currentClass?.toLowerCase().trim() !== classNameOnly.toLowerCase().trim()) {
          return [];
        }
        const lastInvoiceNo =
          invoices.lastinvoiceno ||
          Math.max(
            ...Object.keys(invoices)
              .filter((k) => k !== 'lastinvoiceno' && invoices[k] !== null)
              .map(Number)
          );
        if (!lastInvoiceNo || !invoices[lastInvoiceNo]) {
          return [];
        }
        return Object.keys(invoices[lastInvoiceNo]).map((feeType) => {
          if (feeType.toLowerCase().includes('bus')) return 'bus fee';
          if (feeType.toLowerCase().includes('hostel')) return 'hostel fee';
          if (feeType.toLowerCase().includes('pending')) return 'pending fee';
          if (feeType.toLowerCase().includes('identity') || feeType.toLowerCase().includes('id'))
            return 'identity fee';
          return getBaseFeetype(feeType).toLowerCase().trim();
        });
      })
    )).map((feeType) => {
      const receivedAmount = classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.[feeType] || 0;
      return (
        <div
          key={feeType}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: '#1e293b',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>{feeType.charAt(0).toUpperCase() + feeType.slice(1)}:</span>
          <span>₹{receivedAmount.toFixed(2)}</span>
        </div>
      );
    })}
  </div>
</td>

{/* Pending Column */}
<td
  style={{
    padding: '16px 12px',
    color: '#1e293b',
    verticalAlign: 'middle',
    textAlign: 'center',
  }}
>
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    }}
  >
    {feesForClass.map((feeItem) => {
      const studentCount = getStudentCountForClass(classNameOnly);
      const feeTypeKey = getBaseFeetype(feeItem.feeName).toLowerCase().trim();
      const totalFee = feeItem.totalFee * studentCount;
      const discount = classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.[feeTypeKey] || 0;
      const finalAmount = totalFee - discount;
      const receivedAmount = classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.[feeTypeKey] || 0;
      const pending = finalAmount - receivedAmount;

      return (
        <div
          key={feeItem.id}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: pending > 0 ? '#dc2626' : '#16a34a',
            fontWeight: pending > 0 ? '600' : '400',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>{feeItem.feeName}:</span>
          <span>₹{pending.toFixed(2)}</span>
        </div>
      );
    })}
    {hasHostelFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          color:
            totalHostelFee -
              (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) -
              (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) >
            0
              ? '#dc2626'
              : '#16a34a',
          fontWeight:
            totalHostelFee -
              (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) -
              (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) >
            0
              ? '600'
              : '400',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Hostel Fee:</span>
        <span>
          ₹{(
            totalHostelFee -
            (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0) -
            (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['hostel'] || 0)
          ).toFixed(2)}
        </span>
      </div>
    )}
    {hasBusFee && (
      <div
        style={{
          padding: '6px 8px',
          border: '1px solid #e2e8f0',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '12px',
          color:
            busFeeForClass -
              (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) -
              (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) >
            0
              ? '#dc2626'
              : '#16a34a',
          fontWeight:
            busFeeForClass -
              (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) -
              (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) >
            0
              ? '600'
              : '400',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Bus Fee:</span>
        <span>
          ₹{(
            busFeeForClass -
            (classFeeTypeDiscounts[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0) -
            (classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['bus fee'] || 0)
          ).toFixed(2)}
        </span>
      </div>
    )}
    {pendingFeesForClass.map(([serialNo, amount], i) => {
      const pendingDiscount = getPendingFeeDiscount(serialNo);
      const finalAmount = amount - pendingDiscount;
      const receivedAmount = classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['pending fee'] || 0;
      const pending = finalAmount - receivedAmount;

      return (
        <div
          key={`pending-pending-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: pending > 0 ? '#dc2626' : '#16a34a',
            fontWeight: pending > 0 ? '600' : '400',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Pending Fee :</span>
          <span>₹{pending.toFixed(2)}</span>
        </div>
      );
    })}
    {idFeesForClass.map(([serialNo, amount], i) => {
      const idDiscount = getIdFeeDiscount(serialNo);
      const finalAmount = amount - idDiscount;
      const receivedAmount = classFeeTypeReceived[classNameOnly.toLowerCase().trim()]?.['identity fee'] || 0;
      const pending = finalAmount - receivedAmount;

      return (
        <div
          key={`idfee-pending-${serialNo}`}
          style={{
            padding: '6px 8px',
            border: '1px solid #e2e8f0',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '12px',
            color: pending > 0 ? '#dc2626' : '#16a34a',
            fontWeight: pending > 0 ? '600' : '400',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <span>Identity Fee :</span>
          <span>₹{pending.toFixed(2)}</span>
        </div>
      );
    })}
  </div>
</td>
        </tr>
      </React.Fragment>
    );
  })}
</tbody>
  
                </table>
              </div>
            )}
          </div>

          {/* Summary Section */}
      <div style={{
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  marginBottom: '32px'
}}>
  <h3 style={{
    fontSize: '18px',
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  }}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    Fee Summary
  </h3>

  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '16px'
  }}>
    {Object.values(formattedClassDiv.reduce((acc, classDiv) => {
      const [classNameOnly] = classDiv.split(':');
      const classKey = classNameOnly.toLowerCase().trim();
      const studentCount = getStudentCountForClass(classNameOnly);
      const feesForClass = feeData.filter(
        (feeItem) =>
          feeItem.classType?.toLowerCase().trim() === classKey ||
          feeItem.classType?.toLowerCase().trim() === 'all'
      );

      // Regular fees
      feesForClass.forEach((fee) => {
        const baseFeeType = getBaseFeetype(fee.feeName).toLowerCase().trim();
        if (baseFeeType === 'bus fee') return;

        if (!acc[baseFeeType]) {
          acc[baseFeeType] = {
            id: fee.id,
            baseFeeType,
            classTypes: new Set(),
            totalFee: 0,
            receivedFee: 0,
            pending: 0,
          };
        }

        acc[baseFeeType].classTypes.add(fee.classType);
        const classTotalFee = fee.totalFee * studentCount;
        const discount = classFeeTypeDiscounts[classKey]?.[baseFeeType] || 0;
        const finalAmount = classTotalFee - discount;
        const received = classFeeTypeReceived[classKey]?.[baseFeeType] || 0;
        const pending = finalAmount - received;

        acc[baseFeeType].totalFee += classTotalFee;
        acc[baseFeeType].receivedFee += received;
        acc[baseFeeType].pending += pending;
      });

      // Hostel fees
      const hostelFeesForClass = hostelFeesByClass[classKey] || [];
      if (hostelFeesForClass.length > 0) {
        const baseFeeType = 'hostel fee';
        if (!acc[baseFeeType]) {
          acc[baseFeeType] = {
            id: `hostel-${classKey}`,
            baseFeeType,
            classTypes: new Set([classNameOnly]),
            totalFee: 0,
            receivedFee: 0,
            pending: 0,
          };
        }

        const totalHostelFee = hostelFeesForClass.reduce((sum, entry) => sum + (parseFloat(entry.feeAmount) || 0), 0);
        const discount = classFeeTypeDiscounts[classKey]?.['hostel'] || 0;
        const received = classFeeTypeReceived[classKey]?.['hostel'] || 0;
        const pending = totalHostelFee - discount - received;

        acc[baseFeeType].totalFee += totalHostelFee;
        acc[baseFeeType].receivedFee += received;
        acc[baseFeeType].pending += pending;
      }

      // Bus fees
      const busFeeForClass = busFeeByClass[classKey]?.amount || 0;
      if (busFeeForClass > 0) {
        const baseFeeType = 'bus fee';
        if (!acc[baseFeeType]) {
          acc[baseFeeType] = {
            id: `bus-${classKey}`,
            baseFeeType,
            classTypes: new Set([classNameOnly]),
            totalFee: 0,
            receivedFee: 0,
            pending: 0,
          };
        }

        const discount = classFeeTypeDiscounts[classKey]?.['bus fee'] || 0;
        const received = classFeeTypeReceived[classKey]?.['bus fee'] || 0;
        const pending = busFeeForClass - discount - received;

        acc[baseFeeType].totalFee += busFeeForClass;
        acc[baseFeeType].receivedFee += received;
        acc[baseFeeType].pending += pending;
      }

      // Pending fees
      const pendingFeesForClass = Object.entries(pendingFeesData).filter(
        ([serialNo, _]) => {
          const student = studentData[serialNo];
          return student && student.currentClass?.toLowerCase().trim() === classKey;
        }
      );
      if (pendingFeesForClass.length > 0) {
        const baseFeeType = 'pending fee';
        if (!acc[baseFeeType]) {
          acc[baseFeeType] = {
            id: `pending-${classKey}`,
            baseFeeType,
            classTypes: new Set([classNameOnly]),
            totalFee: 0,
            receivedFee: 0,
            pending: 0,
          };
        }

        const totalPendingFee = pendingFeesForClass.reduce((sum, [, amount]) => sum + amount, 0);
        const discount = pendingFeesForClass.reduce((sum, [serialNo, _]) => sum + getPendingFeeDiscount(serialNo), 0);
        const received = classFeeTypeReceived[classKey]?.['pending fee'] || 0;
        const pending = totalPendingFee - discount - received;

        acc[baseFeeType].totalFee += totalPendingFee;
        acc[baseFeeType].receivedFee += received;
        acc[baseFeeType].pending += pending;
      }

      // ID fees
      const idFeesForClass = Object.entries(idFeesData).filter(
        ([serialNo, _]) => {
          const student = studentData[serialNo];
          return student && student.currentClass?.toLowerCase().trim() === classKey;
        }
      );
      if (idFeesForClass.length > 0) {
        const baseFeeType = 'identity fee';
        if (!acc[baseFeeType]) {
          acc[baseFeeType] = {
            id: `id-${classKey}`,
            baseFeeType,
            classTypes: new Set([classNameOnly]),
            totalFee: 0,
            receivedFee: 0,
            pending: 0,
          };
        }

        const totalIdFee = idFeesForClass.reduce((sum, [, amount]) => sum + amount, 0);
        const discount = idFeesForClass.reduce((sum, [serialNo, _]) => sum + getIdFeeDiscount(serialNo), 0);
        const received = classFeeTypeReceived[classKey]?.['identity fee'] || 0;
        const pending = totalIdFee - discount - received;

        acc[baseFeeType].totalFee += totalIdFee;
        acc[baseFeeType].receivedFee += received;
        acc[baseFeeType].pending += pending;
      }

      return acc;
    }, {})).map((fee, index) => (
      <div key={index} style={{
        backgroundColor: '#dae8f5',
        borderRadius: '8px',
        padding: '16px',
        borderLeft: '4px solid #3b82f6'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '8px'
        }}>
          <span style={{ fontWeight: '600', color: '#1e293b' }}>
            {fee.baseFeeType.charAt(0).toUpperCase() + fee.baseFeeType.slice(1)}
          </span>
          <span style={{
            fontSize: '12px',
            backgroundColor: '#e0f2fe',
            color: '#0369a1',
            padding: '2px 8px',
            borderRadius: '4px'
          }}>
            {[...fee.classTypes].every(ct => ct.toLowerCase() === 'all')
              ? 'All Classes'
              : [...fee.classTypes].join(', ')}
          </span>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '8px',
          marginTop: '12px'
        }}>
          <div>
            <div style={{ fontSize: '12px', color: '#64748b' }}>
              Total Fee
            </div>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1e293b'
            }}>
              ₹{fee.totalFee.toFixed(2)}
            </div>
          </div>
          <div>
            <div style={{ fontSize: '12px', color: '#64748b' }}>
              Received
            </div>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: fee.receivedFee > 0 ? '#16a34a' : '#64748b'
            }}>
              ₹{fee.receivedFee.toFixed(2)}
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '12px', color: '#64748b' }}>
              Pending
            </div>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: fee.pending > 0 ? '#dc2626' : '#16a34a'
            }}>
              ₹{fee.pending.toFixed(2)}
            </div>
          </div>
        </div>

        <div style={{
          marginTop: '12px',
          height: '6px',
          backgroundColor: '#e2e8f0',
          borderRadius: '3px',
          overflow: 'hidden'
        }}>
          <div style={{
            height: '100%',
            width: fee.totalFee > 0
              ? `${Math.min((fee.receivedFee / fee.totalFee) * 100, 100)}%`
              : '0%',
            backgroundColor: '#3b82f6',
            borderRadius: '3px'
          }}></div>
        </div>
      </div>
    ))}
  </div>
</div>
        </div>
      </div>
    </div>
  );
}


export default FeeDashboard;